<ng-container>
  <ng-container *ngIf="!hasSeoContent; else newsletterV1Template">
    <app-newsletter-v2
      [source]="source"
      [title]="newsLetterTitle"
      [voucherType]="newsLetterVoucherType"
      [amount]="newsLetterAmount"
      [color]="color"
      [isSubsidiaryAccount]="isSubsidiaryAccount$ | async"
      [NLDiscount]="NLDiscount"
    ></app-newsletter-v2>
  </ng-container>

  <ng-template #newsletterV1Template>
    <app-newsletter
      [source]="source"
      [newsLetterTitle]="newsLetterTitle"
      [newsLetterVoucherType]="newsLetterVoucherType"
      [newsLetterAmount]="newsLetterAmount"
      [isSubsidiaryAccount]="isSubsidiaryAccount$ | async"
      [isSmallSize]="isSmallSize"
      [NLDiscount]="NLDiscount"
    ></app-newsletter>
  </ng-template>
</ng-container>
